var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('iframe',{attrs:{"src":_vm.src,"width":"100%","height":_vm.ModelHeight,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }